import * as React from 'react';

type InputProps = React.ClassAttributes<HTMLInputElement> &
  React.InputHTMLAttributes<HTMLInputElement> & {
    /** An input doesn't need content. */
    children?: undefined;
    style?: React.CSSProperties;
    maxLength?: number;
  };

/**
 * Inputs are a type of **atom** that represent a `<input>` element.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ style, maxLength, autoComplete, ...rest }, inputRef) => {
    return (
      <input
        maxLength={maxLength}
        css={{
          border: '0.5px solid #D1D5DE',
          borderRadius: '8px',
          boxSizing: 'border-box',
          color: '#373D42',
          display: 'block',
          fontFamily: 'Roboto, sans-serif',
          fontSize: '16px',
          fontWeight: 300,
          lineHeight: '20px',
          padding: '12px 16px',
          whiteSpace: 'nowrap',
          wordBreak: 'keep-all',
          width: '100%',
          '&:disabled, &:read-only': {
            backgroundColor: '#E8EBF0',
          },
          '&:focus': {
            borderColor: '#0074CC',
            outline: 'none',
          },
          '&::placeholder': {
            color: '#373D42',
            fontSize: '14px',
          },
          ...style,
        }}
        {...rest}
        ref={inputRef}
        autoComplete={autoComplete}
      />
    );
  }
);

export default Input;
